import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";
import {
  MuiPickersUtilsProvider,
  DateTimePicker,
} from "@material-ui/pickers";
import ClearIcon from "@material-ui/icons/Clear";
import DateFnsUtils from "@date-io/date-fns";

import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  selectWrapper: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
  },
  dateWrapper: {
    display: "flex",
    marginTop: theme.spacing(2),
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  clearButton: {
    width: "32px",
    height: "32px",
  },
  selectFormControl: {
    width: "125px"
  },
  dtmSelectControl: {
    width: "250px"
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function Form({ submit, user = null, isEdit = false }) {
  const classes = useStyles();
  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();

  const [initTypes, setInitTypes] = React.useState([]);
  const [initMaxWords, setInitMaxWords] = React.useState({});
  const [initMaxTweets, setInitMaxTweets] = React.useState({});
  const [dtms, setDtms] = React.useState([]);

  // ADD 2023.09.30 SLCプラン
  const [initFilterhose, setInitFilterhose] = React.useState([]);

  const [accountName, setAccountName] = React.useState("");
  const [desc, setDesc] = React.useState("");
  const [contractType, setContractType] = React.useState("silver");
  const [fhUser, setFhUser] = React.useState("");
  const [fhPassword, setFhPassword] = React.useState("");
  const [maxWords, setMaxWords] = React.useState(5);
  const [minWords, setMinWords] = React.useState(1);
  const [maxTweets, setMaxTweets] = React.useState(45000);
  const [maxCurrent, setMaxCurrent] = React.useState(45000);
  const [maxUsers, setMaxUsers] = React.useState(10);
  const [maxGroups, setMaxGroups] = React.useState(10);
  const [maxWordsOr, setMaxWordsOr] = React.useState(5);
  const [maxWordsAnd, setMaxWordsAnd] = React.useState(100);
  const [maxWordsNot, setMaxWordsNot] = React.useState(100);
  const [validFrom, setValidFrom] = React.useState(dayjs().format("YYYY-MM-DD 00:00:00"));
  const [validUntil, setValidUntil] = React.useState(null);
  const [limitRelease, setLimitRelease] = React.useState(0);
  const [master, setMaster] = React.useState({
    name: "",
    email: "",
    password: ""
  });
  const [dtmConfig, setDtmConfig] = React.useState({
    dtmNoticeId: "",
    locked: false,
  });
  const [options, setOptions] = React.useState({
    media: false,
    // Add 2023.03.31 投稿分類
    analysis: false,
  });

  // Add 2023.03.31 投稿分類
  const analysConf = {
    noiseDicts : { min : 30,  def : 30,  max : 100 },
    noiseWords : { min : 100, def : 100, max : 500 },
    labelDicts : { min : 30,  def : 30,  max : 100 },
    labelWords : { min : 100, def : 100, max : 500 },
    infos      : { min : 10 , def : 10,  max : 30 },
    procs      : { min : 2,   def : 2,   max : 5 },
    labels     : { min : 5,   def : 5,   max : 30 },
  };

  // Add 2023.03.31 投稿分類
  const [maxNoiseDicts, setMaxNoiseDicts] = React.useState(analysConf.noiseDicts.def);
  const [maxNoiseWords, setMaxNoiseWords] = React.useState(analysConf.noiseWords.def);
  const [maxLabelDicts, setMaxLabelDicts] = React.useState(analysConf.labelDicts.def);
  const [maxLabelWords, setMaxLabelWords] = React.useState(analysConf.labelWords.def);
  const [maxLabels, setMaxLabels] = React.useState(analysConf.labels.def);
  const [maxInfos, setMaxInfos] = React.useState(analysConf.infos.def);
  const [maxProcs, setMaxProcs] = React.useState(analysConf.procs.def);

  let { name, email, password } = master;

  const handleChange = (event) => {
    setMaster({ ...master, [event.target.name]: event.target.value });
  };

  const setDtmNoticeId = (event) => {
    setDtmConfig({ ...dtmConfig, dtmNoticeId: event.target.value });
  };

  const setLocked = (event) => {
    setDtmConfig({ ...dtmConfig, locked: event.target.checked });
  };

  const setMedia = (event) => {
    setOptions({ ...options, media: event.target.checked });
  };

  // Add 2023.03.31 投稿分類
  const setAnalys = (event) => {
    setOptions({ ...options, analysis: event.target.checked });
    /*if (event.target.checked == false) {
        setMaxNoiseDicts(analysConf.noiseDicts.def);
        setMaxNoiseWords(analysConf.noiseWords.def);
        setMaxLabelDicts(analysConf.labelDicts.def);
        setMaxLabelWords(analysConf.labelWords.def);
        setMaxLabels(analysConf.labels.def);
        setMaxInfos(analysConf.infos.def);
        setMaxProcs(analysConf.procs.def);
    }*/
  };

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!user) return;
    setAccountName(user.name);
    setDesc(user.desc);
    setContractType(user.contractType);
    setFhUser(user.fhUser);
    setFhPassword(user.fhPassword);
    setMaxWords(user.maxWords);
    setMaxTweets(user.maxTweets);
    setMaxCurrent(user.maxCurrent);
    setMaxUsers(user.maxUsers);
    setMaxGroups(user.maxGroups);
    setMaxWordsOr(user.maxWordsOr);
    setMaxWordsAnd(user.maxWordsAnd);
    setMaxWordsNot(user.maxWordsNot);
    setValidFrom(user.validFrom);
    setValidUntil(user.validUntil);
    setLimitRelease(user.limitRelease);
    setMaster(user.master);
    setDtmConfig(user.dtmConfig);
    setOptions(user.options);
  }, [user]);

  // Add 2023.03.31 投稿分類
  React.useEffect(() => {
    if (!user) return;
    setMaxNoiseDicts(user.maxNoiseDicts);
    setMaxNoiseWords(user.maxNoiseWords);
    setMaxLabelDicts(user.maxLabelDicts);
    setMaxLabelWords(user.maxLabelWords);
    setMaxLabels(user.maxLabels);
    setMaxInfos(user.maxInfos);
    setMaxProcs(user.maxProcs);
  }, [user]);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchContracts();
    fetchDtms();
  }, [auth.state.token]);
  
  // 契約タイプによって値を変更
  React.useEffect(() => {
    if (contractType === "slc") {
      setFhUser("");
      setFhPassword("");
      setMinWords(20);
    } else {
      setMinWords(1);
    }

    // ADD 2023.09.30 SLCプラン
    // 追加したSLCプランはFHキーワード数の最低値が100
    if (initFilterhose && initFilterhose[contractType] == false && contractType !== "slc" && contractType !== "ruby") {
      setMinWords(100);
    } 

    if (contractType === "ruby") {
      setFhUser("");
      setFhPassword("");
      setMaxWords(5);
      setMinWords(1);
      setMaxTweets(45000);
      setMaxCurrent(45000);
      setMaxUsers(10);
      setMaxGroups(10);
      setMaxWordsOr(5);
      setMaxWordsAnd(100);
      setMaxWordsNot(100);
      setLimitRelease(0);
      setDtmConfig({
        dtmNoticeId: "",
        locked: false,
      });
      setOptions({
        media: true,
        // Add 2023.03.31 投稿分類
        analysis: false,
      });
      // Add 2023.03.31 投稿分類
      setMaxNoiseDicts(analysConf.noiseDicts.def);
      setMaxNoiseWords(analysConf.noiseWords.def);
      setMaxLabelDicts(analysConf.labelDicts.def);
      setMaxLabelWords(analysConf.labelWords.def);
      setMaxLabels(analysConf.labels.def);
      setMaxInfos(analysConf.infos.def);
      setMaxProcs(analysConf.procs.def);
    }
  }, [contractType]);

  const fetchContracts = () => {
    request({
      method: "GET",
      url: `admin/contracts`,
    })
      .then((result) => {
        setInitTypes(result.data.data.types);
        setInitMaxWords(result.data.data.max_words);
        setInitMaxTweets(result.data.data.max_tweets);
        setMaxCurrent(result.data.data.max_tweets);
        // ADD 2023.09.30 SLCプラン
        setInitFilterhose(result.data.data.filterhose);
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const fetchDtms = () => {
    request({
      method: "GET",
      url: `admin/dtm_notices`,
    }).then((result) => {
      setDtms(result.data.data);
    });
  };

  // 契約タイプ変更に伴う値変更
  const changeType = (event) => {
    setContractType(event.target.value);
    setMaxWords(initMaxWords[event.target.value]);
    setMaxTweets(initMaxTweets[event.target.value]);
  }

  // パスワード入力形式確認用バリデーションを追加
  ValidatorForm.addValidationRule('checkPassword', (value) => {
    // UPDATE 2023.09.30 SLCプラン
    //if (contractType === "slc" || contractType === "ruby" || !value) return true; 
    if (initFilterhose[contractType] || !value) return true; 
    // パスワードの正規表現
    //   (?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e]) # lookahead punctuations
    //   (?=.*?[\u0030-\u0039])                                        # lookahead digits
    //   (?=.*?[\u0041-\u005a])                                        # lookahead upper case alphabets
    //   (?=.*?[\u0061-\u007a])                                        # lookahead lower case alphabets
    //   [\u0021-\u007e]{8,32}                                         # 8 to 32 of ascii printables
    const regexp = /^((?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e])(?=.*?[\u0030-\u0039])(?=.*?[\u0041-\u005a])(?=.*?[\u0061-\u007a])([\u0021-\u007e]{8,32}))$/;

    if (!regexp.test(value)) {
      return false;
    } else {
      return true;
    }
  });

  // FHユーザ名/パスワードの条件付き必須チェック
  ValidatorForm.addValidationRule('checkFhUserPassword', (value) => {
    // 契約タイプが「slc」または「ruby」であれば必須チェック不要
    // ADD 2023.09.30 SLCプラン
    //if (contractType != "slc" && contractType != "ruby") {
    if (initFilterhose[contractType]) {
      if (value) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  });

  const dateValidation = (date, type) => {
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY-MM-DD HH:mm:ss").isValid()) {
      if (type == "validFrom") {
        const dateTime = dayjs(validUntil).format("YYYY-MM-DD HH:mm:ss")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD HH:mm:ss")
        // 比較対象がnullなため比較なしでset
        // 終了日付が開始日付より後の日かチェック
        if (!dayjs(dateTime).isValid() || (dayjs(dateTime).isSameOrAfter(dayjs(selectedDateTime)))) {
          setValidFrom(dayjs(date).format("YYYY-MM-DD HH:mm:ss"));
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "validUntil"){
        const dateTime = dayjs(validFrom).format("YYYY-MM-DD HH:mm:ss")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD HH:mm:ss")
        // 比較対象がnullなため比較なしでset
        // 開始日付が終了日付より前の日かチェック
        if (!dayjs(dateTime).isValid() || (dayjs(dateTime).isSameOrBefore(dayjs(selectedDateTime)))) {
          setValidUntil(dayjs(date).format("YYYY-MM-DD HH:mm:ss"));
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    return;
  }

  function clearValidUntil(e) {
    e.stopPropagation();
    setValidUntil(null);
  }

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <ValidatorForm
        onSubmit={(e) => {
          e.preventDefault();
          submit(
            { 
              accountName,
              desc,
              contractType,
              fhUser,
              fhPassword,
              maxWords,
              maxTweets,
              maxCurrent,
              maxUsers,
              maxGroups,
              maxWordsOr,
              maxWordsAnd,
              maxWordsNot,
              validFrom,
              validUntil,
              limitRelease,
              master,
              dtmConfig,
              options,
              // Add 2023.03.31 投稿分類
              maxNoiseDicts,
              maxNoiseWords,
              maxLabelDicts,
              maxLabelWords,
              maxLabels,
              maxInfos,
              maxProcs,
            }
          );
        }}
        onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isEdit ? "アカウント更新" : "アカウント登録"}
          </Typography>
          <Grid container>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="アカウント名*"
                fullWidth
                value={accountName}
                onChange={(event) => {
                  setAccountName(event.target.value);
                }}
                type="text"
                validators={['required']}
                errorMessages={[
                  messages.validation.required,
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="アカウント概要*"
                fullWidth
                value={desc}
                onChange={(event) => {
                  setDesc(event.target.value);
                }}
                type="text"
                validators={['required']}
                errorMessages={[
                  messages.validation.required, 
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <FormControl className={classes.selectFormControl}>
                <InputLabel>契約タイプ</InputLabel>
                <Select
                  value={contractType}
                  onChange={changeType}
                  disabled={isEdit}
                >
                  {initTypes.map((row, index) => 
                    <MenuItem key={index} value={row}>{row}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="FHユーザ名*"
                fullWidth
                value={fhUser}
                onChange={(event) => {
                  setFhUser(event.target.value);
                }}
                type="text"
                // UPDATE 2023.09.30 SLCプラン
                //disabled={isEdit || contractType === "slc" || contractType === "ruby"}
                disabled={isEdit || !initFilterhose[contractType]}
                validators={['checkFhUserPassword']}
                errorMessages={[
                  messages.validation.required, 
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="FHパスワード*"
                autoComplete="new-password"
                fullWidth
                value={fhPassword}
                onChange={(event) => {
                  setFhPassword(event.target.value);
                }}
                type={"text"}
                // UPDATE 2023.09.30 SLCプラン
                //disabled={isEdit || contractType === "slc" || contractType === "ruby"}
                disabled={isEdit || !initFilterhose[contractType]}
                validators={['checkFhUserPassword']}
                errorMessages={[
                  messages.validation.required
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="FHキーワード数"
                fullWidth
                value={maxWords}
                onChange={(event) => {
                  setMaxWords(event.target.value);
                }}
                type="number"
                InputProps={{ inputProps: { min: minWords, step: 10} }}
                validators={['required', 'minNumber:' + minWords]}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "FHキーワード数")).replace("$2", minWords)
                ]}
                // UPDATE 2023.09.30 SLCプラン
                //disabled={isEdit || contractType != "slc"}
                disabled={isEdit || initFilterhose[contractType] ||  contractType === "ruby"}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="FH取得上限値"
                fullWidth
                value={maxTweets}
                type="text"
                disabled
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="登録可能ユーザ数*"
                fullWidth
                value={maxUsers}
                onChange={(event) => {
                  setMaxUsers(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "登録可能ユーザ数")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="登録可能グループ数*"
                fullWidth
                value={maxGroups}
                onChange={(event) => {
                  setMaxGroups(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "登録可能グループ数")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="収集語数上限値*"
                fullWidth
                value={maxWordsOr}
                onChange={(event) => {
                  setMaxWordsOr(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "収集語数上限値")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="絞込語数上限値*"
                fullWidth
                value={maxWordsAnd}
                onChange={(event) => {
                  setMaxWordsAnd(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "絞込語数上限値")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="除外語数上限値*"
                fullWidth
                value={maxWordsNot}
                onChange={(event) => {
                  setMaxWordsNot(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "除外語数上限値")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.dateWrapper}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  label="有効期限開始日時"
                  format="yyyy/MM/dd HH:mm:ss"
                  value={validFrom}
                  onChange={(date) => dateValidation(date, "validFrom")}
                />
              </MuiPickersUtilsProvider>
              <div className={classes.divider}>〜</div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  label="有効期限終了日時"
                  format="yyyy/MM/dd HH:mm:ss"
                  value={validUntil}
                  onChange={(date) => dateValidation(date, "validUntil")}
                  InputProps={{
                    endAdornment: (
                      <IconButton 
                        className={classes.clearButton} 
                        onClick={(e) => clearValidUntil(e)}>
                          <ClearIcon />
                      </IconButton>
                    )
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="上限突破可能回数*"
                fullWidth
                value={limitRelease}
                onChange={(event) => {
                  setLimitRelease(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby"}
                InputProps={{ inputProps: { min: 0} }}
                validators={['required', 'minNumber:0']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "上限突破可能回数")).replace("$2", "0")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="マスタユーザ名*"
                fullWidth
                value={name}
                onChange={handleChange}
                name="name"
                type="text"
                disabled={isEdit}
                validators={['required']}
                errorMessages={[
                  messages.validation.required, 
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="マスタユーザアドレス*"
                fullWidth
                value={email}
                onChange={handleChange}
                name="email"
                type="email"
                disabled={isEdit}
                validators={['required', 'isEmail']}
                errorMessages={[
                  messages.validation.required, 
                  messages.validation.emailRegexp, 
                ]}
              />
            </Grid>
            {!isEdit && (
              <Grid item xs={12} className={classes.wrapper}>
                <TextValidator
                  label="マスタユーザパスワード*"
                  autoComplete="new-password"
                  fullWidth
                  value={password}
                  onChange={handleChange}
                  name="password"
                  type="password"
                  validators={['required', 'checkPassword']}
                  errorMessages={[
                    messages.validation.required,
                    messages.validation.isPasswordRegexp
                  ]}
                />
              </Grid>
            )}
            <Grid item xs={12} className={classes.wrapper}>
              <FormControl className={classes.dtmSelectControl}>
                <InputLabel>告知タイプ</InputLabel>
                <Select
                  value={dtmConfig.dtmNoticeId}
                  onChange={setDtmNoticeId}
                  name="dtmNoticeId"
                  disabled={contractType === "ruby"}
                >
                  <MenuItem value={null}></MenuItem>
                  {dtms.map((row) =>
                    <MenuItem key={row.id} value={row.id}>{row.label}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <FormControl component="fieldset">
                <FormLabel>告知ロック</FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dtmConfig.locked}
                        onChange={setLocked}
                        name="locked"
                        disabled={contractType === "ruby"}
                      />
                    }
                    label="ロック状態"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <FormControl component="fieldset">
                <FormLabel>多メディア</FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={options.media}
                        onChange={setMedia}
                        name="media"
                        disabled={contractType === "ruby"}
                      />
                    }
                    label="多メディアを有効にする"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            {/* Add 2023.03.31 投稿分類  */}
            <Grid item xs={12} className={classes.wrapper}>
              <FormControl component="fieldset">
                <FormLabel>投稿分類</FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={options.analysis}
                        onChange={setAnalys}
                        name="analysis"
                        disabled={contractType === "ruby"}
                      />
                    }
                    label="投稿分類を有効にする"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="ノイズ辞書登録上限数"
                fullWidth
                value={maxNoiseDicts}
                onChange={(event) => {
                  setMaxNoiseDicts(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 30, max: 100} }}
                validators={['required', 'minNumber:30', 'maxNumber:100']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "ノイズ辞書登録上限数")).replace("$2", analysConf.noiseDicts.min),
                  ((messages.validation.maxNumber).replace("$1", "ノイズ辞書登録上限数")).replace("$2", analysConf.noiseDicts.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="ノイズ辞書毎登録キーワード上限数"
                fullWidth
                value={maxNoiseWords}
                onChange={(event) => {
                  setMaxNoiseWords(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 100, max: 500} }}
                validators={['required', 'minNumber:100', 'maxNumber:500']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "ノイズ辞書毎登録キーワード上限数")).replace("$2", analysConf.noiseWords.min),
                  ((messages.validation.maxNumber).replace("$1", "ノイズ辞書毎登録キーワード上限数")).replace("$2", analysConf.noiseWords.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="分類辞書登録上限数"
                fullWidth
                value={maxLabelDicts}
                onChange={(event) => {
                  setMaxLabelDicts(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 30, max: 100} }}
                validators={['required', 'minNumber:30', 'maxNumber:100']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "分類辞書登録上限数")).replace("$2", analysConf.labelDicts.min),
                  ((messages.validation.maxNumber).replace("$1", "分類辞書登録上限数")).replace("$2", analysConf.labelDicts.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="分類辞書毎登録キーワード上限数"
                fullWidth
                value={maxLabelWords}
                onChange={(event) => {
                  setMaxLabelWords(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 100, max: 500} }}
                validators={['required', 'minNumber:100', 'maxNumber:500']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "分類辞書毎登録キーワード上限数")).replace("$2", analysConf.labelWords.min),
                  ((messages.validation.maxNumber).replace("$1", "分類辞書毎登録キーワード上限数")).replace("$2", analysConf.labelWords.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="タスク予約登録上限数"
                fullWidth
                value={maxInfos}
                onChange={(event) => {
                  setMaxInfos(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 10, max: 30} }}
                validators={['required', 'minNumber:10', 'maxNumber:30']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "タスク予約登録上限数")).replace("$2", analysConf.infos.min),
                  ((messages.validation.maxNumber).replace("$1", "タスク予約登録上限数")).replace("$2", analysConf.infos.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="タスク同時実行上限数（毎日予約の1を含む）"
                fullWidth
                value={maxProcs}
                onChange={(event) => {
                  setMaxProcs(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 2, max: 5} }}
                validators={['required', 'minNumber:2', 'maxNumber:5']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "タスク同時実行上限数（毎日予約の1を含む）")).replace("$2", analysConf.procs.min),
                  ((messages.validation.maxNumber).replace("$1", "タスク同時実行上限数（毎日予約の1を含む）")).replace("$2", analysConf.procs.max)
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.selectWrapper}>
              <TextValidator
                label="タスク毎分類辞書登録上限数"
                fullWidth
                value={maxLabels}
                onChange={(event) => {
                  setMaxLabels(event.target.value);
                }}
                type="number"
                disabled={contractType === "ruby" || options.analysis == false}
                InputProps={{ inputProps: { min: 5, max: 30} }}
                validators={['required', 'minNumber:5', 'maxNumber:30']}
                errorMessages={[
                  messages.validation.required,
                  ((messages.validation.minNumber).replace("$1", "タスク毎分類辞書登録上限数")).replace("$2", analysConf.labels.min),
                  ((messages.validation.maxNumber).replace("$1", "タスク毎分類辞書登録上限数")).replace("$2", analysConf.labels.max)
                ]}
              />
            </Grid>
          </Grid>
        </Paper>

        {stateError.state.isError && (
          <div className={classes.messsageWrapper}>
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
              className={classes.toast}
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary">
            {isEdit ? "更新" : "登録"}
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}
